import { TabsService } from './../../pages/tabs/tabs.service';
import { NavController } from 'ionic-angular';
import { Component } from '@angular/core';
import { SessionService } from './../../services/session';
import { LocationsService } from '../../services/locations';
import {BeautyFiltersService} from '../../services/beauty-filters';

@Component({
  selector: 'beauty-summary-header',
  templateUrl: 'beauty-summary-header.html'
})
export class BeautySummaryHeaderComponent {
  constructor(
    public sessionService: SessionService,
    public filtersService: BeautyFiltersService,
    public navCtrl: NavController,
    public tabsService: TabsService,
    public locationsService: LocationsService
  ) {}

  goToMyClasses(classType) {
    this.filtersService.myClassesType = classType;
    this.navCtrl.parent.select(this.tabsService.BEAUTY);
  }
}



// WEBPACK FOOTER //
// ./src/components/beauty-summary-header/beauty-summary-header.ts